import { render, staticRenderFns } from "./CekiDetayBtn.vue?vue&type=template&id=28f225ce"
import script from "./CekiDetayBtn.vue?vue&type=script&lang=js"
export * from "./CekiDetayBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports